<script setup>
import { ref, computed, watch } from 'vue';
import HeaderVariableList from './HeaderVariableList.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'input', 'blur']);

const showVariables = ref(false);
const variableSearchTerm = ref('');

const shouldShowVariables = computed(() => showVariables.value);

watch(
  () => props.modelValue,
  val => {
    const stringValue = String(val || '');
    if (/{{([^{}]*)$/.test(stringValue) && !stringValue.endsWith('}}')) {
      showVariables.value = true;
      const match = stringValue.match(/{{([^{}]*)$/);
      variableSearchTerm.value = match ? match[1] : '';
    } else {
      showVariables.value = false;
    }
  }
);

const insertVariable = variable => {
  const currentValue = String(props.modelValue || '');
  const newValue = currentValue.replace(
    /(.*)(\{{)([^{}]*)$/,
    (match, p1) => p1 + '{{' + variable + '}}'
  );
  showVariables.value = false;
  emit('update:modelValue', newValue);
  emit('input', newValue);
};

const handleInput = event => {
  emit('update:modelValue', event.target.value);
  emit('input', event.target.value);
};

const handleBlur = event => {
  emit('blur', event.target.value);
};
</script>

<template>
  <div class="relative flex w-full">
    <HeaderVariableList
      v-if="shouldShowVariables"
      :search-key="variableSearchTerm"
      @select-variable="insertVariable"
    />
    <input
      v-bind="$attrs"
      type="text"
      :value="modelValue"
      class="answer--text-input flex-1"
      @input="handleInput"
      @blur="handleBlur"
    />
  </div>
</template>
